var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankJpMorgan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5811 3C13.5023 2.99996 13.4243 3.01545 13.3514 3.04558C13.2786 3.07572 13.2125 3.1199 13.1567 3.17562C13.101 3.23134 13.0568 3.2975 13.0266 3.37031C12.9965 3.44312 12.9809 3.52117 12.9809 3.59999V7.80792H24.0931L19.0326 3.00031L13.5811 3ZM24.5 9.08119C24.5002 9.00231 24.4849 8.92415 24.4548 8.85123C24.4247 8.7783 24.3805 8.71205 24.3248 8.65628C24.269 8.60052 24.2027 8.55634 24.1298 8.52629C24.0569 8.49624 23.9787 8.48092 23.8999 8.48121H19.694V19.5973L24.4981 14.533L24.5 9.08119ZM18.4198 20C18.7507 20 19.0194 19.7309 19.0194 19.3988V15.1924H7.90627L12.9676 19.9991L18.4198 20ZM7.5 13.9197C7.5 14.2513 7.76899 14.5216 8.10106 14.5216H12.306V3.40484L7.50092 8.4676L7.5 13.9197Z",
    fill: "#117ACA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankJpMorgan);
export default __webpack_public_path__ + "static/media/BankJPMorgan.d7576019ed900acb922ec0f1cffb5411.svg";
export { ForwardRef as ReactComponent };